import ComingSoon from "@/components/ComingSoon";
import UnderConstructionSvg from "@/components/UnderConstructionSvg";

const MyDevicesPage = () => {
  return <ComingSoon featureName="Under Construction" description="View and manage your enrolled devices. This feature requires backend End-User Portal APIs." illustration={<UnderConstructionSvg />} />;
};

export default MyDevicesPage;
